import { createSvgComponent } from "../../icon/createSvgComponent";
import Send from "@core/__generated__/icon/figma/send.svg";
export default createSvgComponent(Send);